import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=c2666c88"
import script from "./ConfirmButton.vue?vue&type=script&lang=js"
export * from "./ConfirmButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports